export default "__VITE_ASSET__BC9sx9Zo__"